import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
  Icon,
  HStack,
  Text,
  Box,
} from '@chakra-ui/react';
import { Section } from '../layout/Section';
import { SolutionShowcase } from './SolutionShowcase';
import { solutions } from '../../data/solutions';

export const SolutionsSection = () => {
  const sectionBg = useColorModeValue('white', 'gray.900');
  const tabBg = useColorModeValue('gray.100', 'gray.800');
  const selectedTabBg = useColorModeValue('brand.500', 'brand.400');
  const selectedTabColor = useColorModeValue('white', 'white');
  const tabColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Section
      id="solutions"
      title="Featured Solutions"
      subtitle="Specialized platforms we've built for complex domains"
      bg={sectionBg}
    >
      <Tabs variant="soft-rounded" colorScheme="brand" isLazy>
        <TabList
          mb={8}
          flexWrap="wrap"
          justifyContent="center"
          gap={2}
          bg={tabBg}
          p={2}
          borderRadius="xl"
          mx="auto"
          maxW="fit-content"
        >
          {solutions.map((solution) => (
            <Tab
              key={solution.id}
              _selected={{
                bg: selectedTabBg,
                color: selectedTabColor,
              }}
              color={tabColor}
              fontWeight="medium"
              px={{ base: 3, md: 5 }}
              py={2}
            >
              <HStack spacing={2}>
                <Icon as={solution.icon} display={{ base: 'none', md: 'block' }} />
                <Text fontSize={{ base: 'sm', md: 'md' }}>{solution.title.split(' ').slice(0, 2).join(' ')}</Text>
              </HStack>
            </Tab>
          ))}
        </TabList>

        <TabPanels>
          {solutions.map((solution) => (
            <TabPanel key={solution.id} p={0}>
              <Box maxW="4xl" mx="auto">
                <SolutionShowcase solution={solution} />
              </Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Section>
  );
};
